import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Facebook, Youtube, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0f1f3d] text-white py-12 px-4 border-t-2 border-[#a3d977]/20" data-id="element-56">
      <div className="max-w-7xl mx-auto" data-id="element-57">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-8 mb-8 pb-8 border-b border-white/10" data-id="element-58">
          {/* Logo and Address */}
          <div className="flex flex-col sm:flex-row items-start gap-6" data-id="element-59">
            <Link to="/" className="flex items-center" data-id="element-60">
              <img src="https://cdn.magicpatterns.com/uploads/tu5GNqxjZDMpJfuNLHyDAD/NorthwestBlackBeltAcademy_logoCROPPEDTrans.png" alt="NWBBA Logo" className="h-16 w-auto" data-id="element-61" />
            </Link>

            <a href="https://www.google.com/maps/place/3815+196th+St+SW+%23109,+Lynnwood,+WA+98036" target="_blank" rel="noopener noreferrer" className="flex items-start gap-2 text-gray-300 hover:text-white transition-colors group" data-id="element-62">
              <MapPin className="w-5 h-5 text-[#a3d977] shrink-0 mt-0.5" data-id="element-63" />
              <div className="text-sm leading-tight" data-id="element-64">
                <div className="font-semibold" data-id="element-65">3815 196th St SW #109</div>
                <div data-id="element-66">Lynnwood, WA 98036</div>
              </div>
            </a>
          </div>

          {/* Navigation Links */}
          <nav className="flex flex-wrap gap-x-6 gap-y-2" data-id="element-67">
            <Link to="/about" className="text-sm font-semibold text-gray-300 hover:text-white transition-colors" data-id="element-68">
              About
            </Link>
            <Link to="/classes" className="text-sm font-semibold text-gray-300 hover:text-white transition-colors" data-id="element-69">
              Classes
            </Link>
            <Link to="/schedule" className="text-sm font-semibold text-gray-300 hover:text-white transition-colors" data-id="element-70">
              Schedule
            </Link>
            <Link to="/resources" className="text-sm font-semibold text-gray-300 hover:text-white transition-colors" data-id="element-71">
              Resources
            </Link>
            <Link to="/blog" className="text-sm font-semibold text-gray-300 hover:text-white transition-colors" data-id="element-72">
              Blog
            </Link>
            <Link to="/proof" className="text-sm font-semibold text-gray-300 hover:text-white transition-colors" data-id="element-73">
              Proof
            </Link>
          </nav>

          {/* Contact CTA and Social Icons */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4" data-id="element-74">
            <Link to="/contact" className="px-6 py-2.5 bg-[#dc2626] text-white text-sm font-bold rounded-lg hover:bg-red-700 transition-colors border-2 border-[#a3d977]/30" data-id="element-75">
              Contact Us
            </Link>

            <div className="flex items-center gap-3 pl-0 sm:pl-3 sm:ml-3 sm:border-l border-white/20" data-id="element-76">
              <a href="https://www.facebook.com/NwBlackBeltAcademy/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors" aria-label="Facebook" data-id="element-77">
                <Facebook className="w-5 h-5" data-id="element-78" />
              </a>
              <a href="https://www.youtube.com/channel/UCVz3NW22j-95JDLAvEWXrHw" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-[#dc2626] transition-colors" aria-label="YouTube" data-id="element-79">
                <Youtube className="w-5 h-5" data-id="element-80" />
              </a>
              <a href="https://www.instagram.com/nw_black_belt_academy/?hl=en" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors" aria-label="Instagram" data-id="element-81">
                <Instagram className="w-5 h-5" data-id="element-82" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Section - Copyright */}
        <div className="text-center" data-id="element-83">
          <p className="text-gray-400 text-sm" data-id="element-84">
            &copy; {new Date().getFullYear()} Northwest Black Belt Academy. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}